/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { UserDetails } from './user-details.model';

export enum FinalizationType {
  ORG_SAML_LOGIN_REQUIRED = 'ORG_SAML_LOGIN_REQUIRED',
  AUTH_SUCCESS = 'AUTH_SUCCESS',
}

export interface LoginFinalizationResponse {
  accessToken?: string;
  message?: string;
  type?: FinalizationType;
  redirect?: string;
  user: UserDetails;
}

export interface TokenValidationResponse {
  email: string;
  affiliationSelectionEnabled: boolean;
}

export type MagicLinkResponseType =
  | 'AUTH_SUCCESS'
  | 'TOKEN_NOT_FOUND'
  | 'TOKEN_EXPIRED'
  | 'TOKEN_ALREADY_USED'
  | 'ORG_MISMATCH'
  | 'ACCOUNT_NOT_VERIFIED'
  | 'ORG_INACTIVE'
  | 'AUTH_ERROR';

export interface MagicLinkLoginResponse {
  accessToken?: string;
  message?: string;
  type: MagicLinkResponseType;
  redirect?: string;
  user?: UserDetails;
}

/**
 * `TOTP_REQUIRED` distinguishes "the account is TOTP-enrolled and needs a code" from a plain
 * wrong-password failure, letting the v3 login form reveal the code field only when actually
 * needed instead of unconditionally for every login attempt.
 */
export type LoginErrorCode = 'TOTP_REQUIRED' | 'INVALID_CREDENTIALS' | 'OTHER';

export interface LoginAuthError {
  code: LoginErrorCode;
  message: string;
}

export interface LoginAuthResult {
  isSuccess: boolean;
  value?: UserDetails;
  error?: LoginAuthError;
}
